"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PlanCardHeader = _ref => {
  var _plan$selectedVariant, _plan$selectedVariant2, _plan$selectedVariant3, _plan$selectedVariant4, _plan$selectedVariant5, _priceAlteration$pric, _priceAlteration$pric2, _priceAlteration$pric3, _plan$selectedVariant6, _plan$selectedVariant7, _plan$selectedVariant8, _plan$selectedVariant9, _plan$selectedVariant10, _plan$selectedVariant11;
  let {
    plan
  } = _ref;
  const price = (_plan$selectedVariant = plan.selectedVariant.price) === null || _plan$selectedVariant === void 0 ? void 0 : (_plan$selectedVariant2 = _plan$selectedVariant[0]) === null || _plan$selectedVariant2 === void 0 ? void 0 : _plan$selectedVariant2.priceValue;
  const priceAlteration = plan === null || plan === void 0 ? void 0 : (_plan$selectedVariant3 = plan.selectedVariant) === null || _plan$selectedVariant3 === void 0 ? void 0 : (_plan$selectedVariant4 = _plan$selectedVariant3.price) === null || _plan$selectedVariant4 === void 0 ? void 0 : (_plan$selectedVariant5 = _plan$selectedVariant4[0]) === null || _plan$selectedVariant5 === void 0 ? void 0 : _plan$selectedVariant5.priceAlteration;
  const priceAlterationValue = priceAlteration === null || priceAlteration === void 0 ? void 0 : (_priceAlteration$pric = priceAlteration.price) === null || _priceAlteration$pric === void 0 ? void 0 : (_priceAlteration$pric2 = _priceAlteration$pric[0]) === null || _priceAlteration$pric2 === void 0 ? void 0 : (_priceAlteration$pric3 = _priceAlteration$pric2.taxIncludedAmount) === null || _priceAlteration$pric3 === void 0 ? void 0 : _priceAlteration$pric3.value;
  const valueAfterDiscount = price - priceAlterationValue;
  const priceAlterationDuration = priceAlteration === null || priceAlteration === void 0 ? void 0 : priceAlteration.applicationDuration;
  const priceTermAmount = plan === null || plan === void 0 ? void 0 : (_plan$selectedVariant6 = plan.selectedVariant) === null || _plan$selectedVariant6 === void 0 ? void 0 : (_plan$selectedVariant7 = _plan$selectedVariant6.price) === null || _plan$selectedVariant7 === void 0 ? void 0 : (_plan$selectedVariant8 = _plan$selectedVariant7[0]) === null || _plan$selectedVariant8 === void 0 ? void 0 : _plan$selectedVariant8.durationAmount;
  const priceTermUnit = plan === null || plan === void 0 ? void 0 : (_plan$selectedVariant9 = plan.selectedVariant) === null || _plan$selectedVariant9 === void 0 ? void 0 : (_plan$selectedVariant10 = _plan$selectedVariant9.price) === null || _plan$selectedVariant10 === void 0 ? void 0 : (_plan$selectedVariant11 = _plan$selectedVariant10[0]) === null || _plan$selectedVariant11 === void 0 ? void 0 : _plan$selectedVariant11.durationUnit;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 2
    },
    layout: valueAfterDiscount ? {
      sm: [6, 6]
    } : {
      sm: [8, 4]
    },
    spacing: 3,
    verticalAlign: "top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: `recommendation-plan-name`
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 1,
    level: 2,
    justify: "left",
    text: {
      main: plan.productName
    }
  })), valueAfterDiscount ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 3,
    level: 2,
    justify: "left",
    text: {
      mainSuffix: ` ${_services.locale.localeString('Recommendation.discountPrefix')} 
              ${priceAlterationDuration} 
              ${_services.locale.localeString('Recommendation.months')}`,
      main: _services.locale.formatPrice(valueAfterDiscount),
      suffix: `${_services.locale.formatPrice(price)} 
              ${_services.locale.localeString('Recommendation.thereafter')}`
    }
  })) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 3,
    level: 2,
    justify: "right",
    text: {
      prefix: `${priceTermAmount} ${priceTermUnit}`,
      main: _services.locale.formatPrice(price)
    }
  }));
};
var _default = PlanCardHeader;
exports.default = _default;